import React from 'react';

/*
  Pieces the ordering panels share, in OnHand's house style (the panels of
  Warehouses and Users & Access), 12 October 2026.
*/

/* A titled section of the panel, as the house panels have. */
export function Section({ title, note, children, right }) {
  return (
    <div className="ua-section">
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 12, flexWrap: 'wrap' }}>
        <div className="ua-section-head" style={{ flex: 1, minWidth: 0 }}>
          <div className="ua-section-title" style={{ fontSize: 15 }}>{title}</div>
          {note && <div className="ua-section-note" style={{ fontSize: 13 }}>{note}</div>}
        </div>
        {right}
      </div>
      {children}
    </div>
  );
}

